import React, {useEffect, useState, useRef} from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
//components
import Btn from '../../../../components/buttons/standard/btn';
import Notification from '../../../../components/side_notification/side_notification';
import MasterPopup from '../../../../components/popups/main_popup';
import { SimpleDropdownContainer } from '../../../../components/dropdowns/simple_dropdown/simple_dropdown';
//sections
import RoiCalculator from './components/roiCalculator/roi_calculator';
//utils
import { getClientData, postReqOptBuilder } from '../../../../utils/main_utils';
//styles
import "./home.css";
import "./landingPageAB2801.css";
//assets
import logo from "../../../../assets/icons/logo.svg"
import ddArrow from "../../../../assets/icons/dd-arrow.svg";
import gridBG from "../../../../assets/icons/GridBG.svg";
import paraspotIcon from "../../../../assets/icons/logo-icon.png";
import warningIcon from "../../../../assets/icons/round_red_warning.png";
import dashboardImg from "../../../../assets/icons/dashboardImg.png";
import facebook from "../../../../assets/landing_page/facebook-2.svg";
import instagram from "../../../../assets/landing_page/instagram-2.svg";
import linkedin from "../../../../assets/landing_page/linkedin-2.svg";
import twitter from "../../../../assets/landing_page/twitter-2.svg";
import bannerVideo from "../../../../assets/landing_page/banner_video2.mp4";
import ContactForm from './components/contact/contactUs';
import guyInOffice from "../../../../assets/california/guy_in_office.png";
import courtMedia from "../../../../assets/california/court.png";
import picOfHome from "../../../../assets/california/part_of_home.png";
import picsOnLaptop from "../../../../assets/california/pics_on_laptop.png";
import buildiumLogo from "../../../../assets/integrations/BuildiumLogo.png";
import appfolioLogo from "../../../../assets/integrations/appfolioLogo.png";
import arthurLogo from "../../../../assets/integrations/ArthurLogo.png";
import rentManagerLogo from "../../../../assets/integrations/rentManagerLogo.png";
import rentvineLogo from "../../../../assets/integrations/rentvineLogo.png";
import propertywareLogo from "../../../../assets/integrations/propertywareLogo.png";


export default function LandingPageAB2801(props) {
    const history = useHistory();

    const [clientData, setClientData] = useState(null);
    const [notifState, setNotifState] = useState(false);
    const [popupState, setPopupState] = useState(null);
    const [showFaq, setShowFaq] = useState(null);
    const [breakdownTableStates, setBreakdownTableStates] = useState([
        { // 1
            reqMain: "Full Documentation of Property Condition",
            reqSub: "(Inspections must be documented at beginning and end of tenancy)",
            state: true,
            currentPractices: <>
                Manual photos (60+ per unit)<br/>
                Risk of missed areas. Time-consuming and disorganized.
            </>,
            Paraspot: <>
                <b>A single guided walkthrough video covering the entire property.</b>
                <ul style={{padding: '0', margin: '0'}}>
                    <li style={{padding: '0', margin: '0'}}>Fast, complete, no missed areas.</li>
                    <li style={{padding: '0', margin: '0'}}>3 minutes total vs hours of manual work.</li>
                </ul>
            </>
        },
        { // 2
            reqMain: "Photographic Proof After Repairs / Cleaning",
            reqSub: "",
            state: true,
            currentPractices: <>
                Manual pile of images taken before and after work order is done.
            </>,
            Paraspot: <>
                <b>Video at move-out, and after repairs/cleaning are done</b>
            </>
        },
        { // 3
            reqMain: "Itemized Statement of Deductions with Evidence",
            reqSub: "",
            state: true,
            currentPractices: <>
                Staff manually searches through countless photos to find the correct ones that 
                show the area of the property from move-in, and figure out if the damage was there before.
            </>,
            Paraspot: <>
                <b>AI-generated itemized statements created automatically.</b>
            </>
        },
        { // 4
            reqMain: "Tenant Right to Pre-Move-Out Inspection",
            reqSub: "",
            state: true,
            currentPractices: <>
                Staff must perform an additional inspection, coordinate scheduling, and manually record inspections.
            </>,
            Paraspot: <>
                <b>Avoid scheduling and offload the pre-move-out inspection to your tenant.</b>
            </>
        },
        { // 5
            reqMain: "Strict 21-Day Timeline to Return Security Deposit and Documentation",
            reqSub: "",
            state: true,
            currentPractices: <>
                Staff must complete the inspection immediately after move-out, find out if any of the issues existed at move-in, 
                prepare an itemized statement, execute the repairs and cleaning, take photographic proof of work done, collect receipts, 
                and build an itemized statement that includes everything within 21 days.
            </>,
            Paraspot: <>
                <b>Staff is prepared for the turnover immediately upon move-out, and already has a punch list in hand.</b>
            </>
        },
        { // 6
            reqMain: "Restricted Use of Security Deposits",
            reqSub: "",
            state: true,
            currentPractices: <>
                Risky manual evaluation.
            </>,
            Paraspot: <>
                <b>
                    AI helps standardize wear and tear definition across your portfolio, 
                    and immediately shows your staff if the damage existed at move-in.
                </b>
            </>
        },
        { // 7
            reqMain: "Prohibition on Cleaning Charges Unless Truly Necessary",
            reqSub: "",
            state: true,
            currentPractices: <>
                Subjective, manual evaluations
            </>,
            Paraspot: <>
                <b>Objective Al assessment of cleanliness.</b>
            </>
        },
    ]);
    const scrollToForm = useRef(null);
    
    useEffect(()=> {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        try {
            getClientData().then(data => {
                setClientData(data);
                fetch(props.para_be + '/log_entry', postReqOptBuilder({ip: data ? data[0] : null}, false))
                .then(response => {
                    console.log("Entry log status:", response.status);
                    console.log("Entry log Response:", response.text());
                })
                .catch(e => {
                    console.error("Error logging entry:", e);
                });
            })
            .catch(e => {
                console.error("Error getting client data:", e);
            });
        } catch (e) {
            console.error("Error getting client data or logging entry:", e);
        }

        if (window.location.hash === "#request_demo") {
            executeScroll();
        }
        // Init Vector
        initVector(window, document);
        try {
            window.vector.load("b665f7cd-9759-4819-a2f3-8d38defbe572");
        } catch (e) {
            console.error("Error loading vector:", e);
        }
        // Init MailerLite & Hotjar
        initMailerLite();
        initHotjar();
    // eslint-disable-next-line no-sequences
    }, []);

    const executeScroll = (e) => scrollToForm.current.scrollIntoView();

    function initVector(e,r) {
        try{
            if (e.vector) return void
            console.log("Vector snippet included more than once.");
            var t={};
            t.q=t.q||[];
            for(
                var o=["load","identify","on"],
                n=function(e) {
                    return function() {
                        var r=Array.prototype.slice.call(arguments);
                        t.q.push([e,r])
                    }
                },
                c=0; c<o.length; c++
            ) {
                var a=o[c];
                t[a]=n(a)
            }
            if (e.vector=t,!t.loaded) {
                var i=r.createElement("script");
                i.type="text/javascript";i.async=!0;i.src="https://cdn.vector.co/pixel.js";
                var l=r.getElementsByTagName("script")[0];
                l.parentNode.insertBefore(i,l);
                t.loaded=!0
            }
        } catch(e) {
            console.error("Error loading Vector:",e)
        }
    }

    function initMailerLite() {
        try {
            const internalFunction = function(w,d,e,u,f,l,n){
                w[f]=w[f]||function(){
                    (w[f].q=w[f].q||[]).push(arguments);
                };
                l=d.createElement(e);
                l.async=1;
                l.src=u;
                n=d.getElementsByTagName(e)[0];
                n.parentNode.insertBefore(l,n);
            };
            internalFunction(window,document,'script','https://assets.mailerlite.com/js/universal.js','ml');
            window.ml('account', '1401304');
        } catch (e) {
            console.error("MailerLite failed to load");
        }
    }

    function initHotjar() {
        const internalFunction = function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:6383761,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        };
        internalFunction(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    }


    return (
        <div className="in-homepage-container">
            <Helmet>
                <title>Paraspot AI | Remote and Automatic Property Inspections</title>
                <meta name="description" content="Paraspot AI revolutionizes property inspections with AI-powered remote scans, reducing costs, boosting tenant satisfaction, and eliminating security deposit disputes for property managers in multifamily, single-family, and rental markets. Put your operations on autopilot!"/>
                <meta property="og:title" content="Paraspot AI | Remote and Automatic Property Inspections"/>
                <meta property="og:description" content="Paraspot AI revolutionizes property inspections with AI-powered remote scans, reducing costs, boosting tenant satisfaction, and eliminating security deposit disputes for property managers in multifamily, single-family, and rental markets. Put your operations on autopilot!"/>
                <meta name="robots" content="index, follow"/>
            </Helmet>

            <div className='in-homepage-nav-wrapper-parent'>
                <div className='in-homepage-nav-wrapper'>
                    <div className='in-homepage-nav flexRow'>
                        <a className='in-homepage-nav-logo flexRow' href="/">
                            <img src={logo} alt="Paraspot AI Logo"/>
                        </a>
                        <div className='in-homepage-nav-links flexRow'>
                            <SimpleDropdownContainer 
                                extraClasses="in-nav-link flexRow show-on-hover desktop-only"
                                showDropdown={false}
                                borderedItems={false}
                                items={{
                                    'california': {
                                        'content': <>
                                            <a href="/california">California</a>
                                        </>, 
                                        'present': 'California', 
                                        'onclick': (k, e) => history.push('/california')
                                    },
                                }}>
                                <div className='in-homepage-nav-link text-0 cursor-pointer'>Compliance & Regulation</div>
                                <img src={ddArrow} alt="arrow-down"/>
                            </SimpleDropdownContainer>
                            <SimpleDropdownContainer 
                                extraClasses="in-nav-link flexRow show-on-hover d-none"
                                showDropdown={false}
                                borderedItems={false}
                                items={{
                                    'multifamily': {'present': 'Multifamily', 'onclick': (k, e) => history.push('/solutions/multifamily')},
                                    'single_family': {'present': 'Single Family', 'onclick': (k, e) => history.push('/solutions/single-family')},
                                    'student_housing': {'present': 'Student Housing', 'onclick': (k, e) => history.push('/solutions/student-housing')},
                                    'serviced_apartments': {'present': 'Furnished Rentals & Co-Living', 'onclick': (k, e) => history.push('/solutions/furnished-rentals-co-living')},
                                    'str': {'present': 'Short-Term Rentals', 'onclick': (k, e) => history.push('/solutions/str')},
                                }}>
                                <div className='in-homepage-nav-link text-0'>Solutions</div>
                                <img src={ddArrow} alt="arrow-down"/>
                            </SimpleDropdownContainer>
                            <SimpleDropdownContainer 
                                extraClasses="in-nav-link flexRow show-on-hover d-none"
                                showDropdown={false}
                                borderedItems={false}
                                items={{
                                    'blog': {'present': 'Blog', 'onclick': (k, e) => history.push('/resources/blog')},
                                    'faqs': {'present': 'FAQs', 'onclick': (k, e) => history.push('/resources/faqs')},
                                    'integrations': {'present': 'Integrations', 'onclick': (k, e) => history.push('/resources/integrations')},
                                    'api_documentation': {'present': 'API Documentation', 'onclick': (k, e) => history.push('/resources/documentation')},
                                }}>
                                <div className='in-homepage-nav-link text-0'>Resources</div>
                                <img src={ddArrow} alt="arrow-down"/>
                            </SimpleDropdownContainer>
                            <SimpleDropdownContainer 
                                extraClasses="in-nav-link flexRow show-on-hover d-none"
                                showDropdown={false}
                                borderedItems={false}
                                items={{
                                    'mission': {'present': 'Our Mission', 'onclick': (k, e) => history.push('/about-us/our-mission')},
                                    'team': {'present': 'Team', 'onclick': (k, e) => history.push('/about-us/team')},
                                    'contact_us': {'present': 'Contact Us', 'onclick': (k, e) => history.push('/about-us/contact-us')},
                                }}>
                                <div className='in-homepage-nav-link text-0'>About Us</div>
                                <img src={ddArrow} alt="arrow-down"/>
                            </SimpleDropdownContainer>
                        </div>
                        <div className='in-hopepage-nav-cta flexRow'>
                            <Btn text="Log In" type="secondary" extraClasses="btn-no-border btn-no-bg text-3-2 btn-radius6" onclick={() => { history.push("/login"); }}/>
                            <Btn text="Request Demo" type="primary-black" extraClasses="text-3-2 btn-radius6" onclick={executeScroll}/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='in-homepage-viewport'>
                <div style={{height: '100%', overflow: 'hidden'}}>
                    <img className='in-homepage-viewport-bg' src={gridBG} alt="bg"/>
                </div>
                <div className='in-ab2801-viewport-bg-radial'/>

                <div className='flexRow pt-32 pb-12 md:pb-24 md:px-16 max-w-7xl z-10 mx-auto'>
                    <div className="flex-col z-10" style={{width: '50vw', marginRight: '60px'}}>
                        <h1 className='h1 px-2'>
                            California Regulations Demands More Than Just Pictures. We Deliver Proof.
                        </h1>
                        <h2 className='text-0 px-2 mt-6 mb-10'>
                            Other solutions give you a pile of photos. Paraspot gives you a full, verified property record - in minutes, not hours.
                        </h2>
                        <div className="flexRow">
                            <Btn 
                                text={"Request Demo"} 
                                onclick={executeScroll}
                                type="primary" 
                                extraClasses="text-3-2 cta-arrow-btn btn-radius6 mr-4" />
                            {/* <Btn 
                                text={"See How it Works"} 
                                onclick={executeScroll}
                                type="secondary" 
                                extraClasses="text-1-3 btn-secondary-selected btn-radius6 btn-no-bg btn-no-break" /> */}
                        </div>
                    </div>
                    <div className="z-10">
                        <div className="viewport-media">
                            <video src={bannerVideo} style={{height: '100%', width: 'max-content', objectFit: 'cover'}} type="video/mp4" autoplay="" loop muted={true}/>
                        </div>
                    </div>

                </div>
            </div>

            <div className='in-ab2801-problem'>
                <div className='in-ab2801-problem-content flexRow'>
                    <div className='in-ab2801-problem-l' style={{position: 'relative', overflow: 'hidden'}}>
                        <div>
                            <img className='in-ab2801-pne-grid-bg' src={gridBG} alt="bg"/>
                        </div>
                        <div className='in-ab2801-pne-bg-radial'></div>
                        <div className="in-ab2801-pne-content">
                            <h2 className='h2'>
                                Photos Aren't Enough Anymore
                            </h2>
                            <div style={{marginTop: '60px'}}>
                                {[
                                    {
                                        bg: picsOnLaptop,
                                        text: "60+ photos per inspection - messy, incomplete, unreliable"
                                    },
                                    {
                                        bg: picOfHome,
                                        text: "Missed damages = lost deposit disputes"
                                    },
                                    {
                                        bg: courtMedia,
                                        text: "No easy before/after comparisons = legal exposure"
                                    },
                                    {
                                        bg: guyInOffice,
                                        text: "Hours of manual labor per inspection"
                                    },
                                ].map((item) => (
                                    <div className='ab2801-pne-item flexRow'>
                                        <img src={item.bg} alt="" className='ab2801-pne-item-bg'/>
                                        <div className="ab2801-pne-item-content ml-auto h3">
                                            {item.text}
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className='in-ab2801-why-us'>
                        <div className='in-ab2801-wu-bg-radial1'></div>
                        <div className='in-ab2801-wu-bg-radial2'></div>
                        <div className='in-ab2801-wu-content'>
                            <h2 className='h2'>
                                Why Property Managers
                                Are Choosing Paraspot
                            </h2>
                            <div style={{marginTop: '60px'}}>
                                {[
                                    {
                                        gradient: "linear-gradient(90deg, rgba(52, 132, 245, 0.2) 0%, rgba(197, 111, 219, 0.2) 100%)",
                                        labelColor: "linear-gradient(90deg, #006AFF 0%, #C56FDB 100%)",
                                        label: "AI-Guided Inspections",
                                        title: "Complete Coverage, Fast",
                                        text: "A single guided walkthrough video covers the entire property in minutes. Ensuring you never miss anything."
                                    },
                                    {
                                        gradient: "linear-gradient(90deg, rgba(255, 235, 245, 0.6) 0%, rgba(255, 173, 173, 0.6) 100%)",
                                        labelColor: "linear-gradient(90deg, #FF0080 0%, #F5222D 100%)",
                                        label: "AI Damage Detection",
                                        title: "Detailed and Fully Automated",
                                        text: "Automatically detects issues, add descriptions, and provides price estimates - instantly."
                                    },
                                    {
                                        gradient: "linear-gradient(90deg, rgba(249, 203, 40, 0.16) 0%, rgba(255, 110, 65, 0.16) 100%)",
                                        labelColor: "linear-gradient(90deg, #F9CB28 0%, #FF6E41 100%)",
                                        label: "Before & After Magic",
                                        title: "Centralized Statement, Organized Effortlessly",
                                        text: "Extract before-and-after comparisons side-by-side. No guesswork, no disputes."
                                    },
                                    {
                                        gradient: "linear-gradient(90deg, rgba(52, 132, 245, 0.2) 0%, rgba(197, 111, 219, 0.2) 100%)",
                                        labelColor: "linear-gradient(90deg, #006AFF 0%, #C56FDB 100%)",
                                        label: "Bulletproof Documentation",
                                        title: "Fully Compliant",
                                        text: "Bulletproof documentation with full video evidence, issue tracking, and proof of condition."
                                    },
                                ].map((item) => (
                                    <div className='ab2801-wu-item'>
                                        <div className="ab2801-wu-item-label" style={{background: item.gradient}}>
                                            <p 
                                                style={{
                                                    background: item.labelColor,
                                                    "-webkit-background-clip": 'text',
                                                    "-webkit-text-fill-color": "transparent",
                                                    "background-clip": "text",
                                                    "text-fill-color": "transparent"
                                                }}
                                            >
                                                {item.label}
                                            </p>
                                        </div>
                                        <h2 className='h3'>
                                            {item.title}
                                        </h2>
                                        <p className='text-1'>
                                            {item.text}
                                        </p>
                                    </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="in-ab2801-hwd">
                <div className='in-ab2801-hwd-bg'>
                    <img src={gridBG} alt="bg"/>
                </div>
                <div className='in-ab2801-hwd-radial'/>
                <div className="in-ab2801-hwd-content">
                    <h2 className="h2" style={{margin: "190px auto 66px", width: 'fit-content', textAlign: 'center'}}>
                        How Paraspot Makes<br/>
                        AB 2801 Compliance Easy
                    </h2>
                    <div style={{margin: '0 40px'}}>
                    <div className="in-ab2801-breakdown-table mobile-only">
                        {breakdownTableStates.map((row, idx) => (
                            <div className={"flexColumn text-1 mb-9" + (row.state ? "" : " in-ab2801-row-hidden")}>
                                <div 
                                    className="in-ab2801-bt-cell cursor-pointer" 
                                    onClick={() => setBreakdownTableStates((prev) => {
                                        const updated = [...prev];
                                        updated[idx] = {...updated[idx], state: !updated[idx].state};
                                        return updated; 
                                    })}
                                >
                                    <div className="flexRow">
                                        <div className="in-ab2801-bt-req-content" style={{width: "calc(100% - 36px)"}}>
                                            <div className='in-ab2801-bt-req-main'>
                                                {row.reqMain}
                                            </div>
                                            {row?.reqSub &&
                                                <div className='in-ab2801-bt-req-extra'>
                                                    {row.reqSub}
                                                </div>
                                            }
                                        </div>
                                        <div className='in-ab2801-bt-state'>
                                            <img src={ddArrow} alt='arrow' style={{width: "12px"}} />
                                        </div>
                                    </div>
                                </div>
                                <div className={"in-ab2801-row-content-wrapper"}>
                                    <div className="in-ab2801-bt-cell">
                                        <div className='flexRow mb-3'>
                                            <div className='in-ab2801-bt-col-icon mr-2'>
                                                <img src={warningIcon} alt="warning"/>
                                            </div>
                                            <div className='in-ab2801-bt-col-content'>
                                                <b>Current Practices</b><br/>
                                            </div>
                                        </div>
                                        <div className='in-ab2801-bt-col-content'>
                                            {row.currentPractices}
                                        </div>
                                    </div>
                                    <div className="in-ab2801-bt-cell">
                                        <div className='flexRow mb-3'>
                                            <div className='in-ab2801-bt-col-icon mr-2'>
                                                <img src={paraspotIcon} alt="Paraspot"/>
                                            </div>
                                            <div className='in-ab2801-bt-col-content'>
                                                <b>How Paraspot is Different</b><br/>
                                            </div>
                                        </div>
                                        <div className='in-ab2801-bt-col-content'>
                                            {row.Paraspot}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                        }
                    </div>
                    <table className='in-ab2801-breakdown-table hide-mobile'>
                        <thead>
                            <tr>
                                <th>California Regulation Requirements</th>
                                <th>Current Practices</th>
                                <th>How Paraspot is different</th>
                            </tr>
                        </thead>
                        <tbody>
                            {breakdownTableStates.map((row, idx) => (
                                <tr 
                                    className={row.state ? "" : " in-ab2801-row-hidden"}
                                    onClick={() => setBreakdownTableStates((prev) => {
                                        const updated = [...prev];
                                        updated[idx] = {...updated[idx], state: !updated[idx].state};
                                        return updated; 
                                    })}
                                >
                                    <td>
                                        <div className='flexRow' style={{maxHeight: !row.state ? '42px' : ''}}>
                                            <div className='in-ab2801-bt-state'>
                                                <img src={ddArrow} alt='arrow' style={{width: "12px"}} />
                                            </div>
                                            <div className="in-ab2801-bt-req-content" style={{width: "calc(100% - 36px)"}}>
                                                <div className='in-ab2801-bt-req-main'>
                                                    {row.reqMain}
                                                </div>
                                                {row?.reqSub &&
                                                    <div className='in-ab2801-bt-req-extra'>
                                                        {row.reqSub}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className='flexRow' style={{maxHeight: !row.state ? '42px' : ''}}>
                                            <div className='in-ab2801-bt-col-icon'>
                                                <img src={warningIcon} alt="warning"/>
                                            </div>
                                            <div className='in-ab2801-bt-col-content'>
                                                {row.currentPractices}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className='flexRow' style={{maxHeight: !row.state ? '42px' : ''}}>
                                            <div className='in-ab2801-bt-col-icon'>
                                                <img src={paraspotIcon} alt="Paraspot"/>
                                            </div>
                                            <div className='in-ab2801-bt-col-content'>
                                                {row.Paraspot}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>

                    <div style={{margin: '50px auto 100px', width: 'fit-content'}}>
                        <Btn 
                            text={
                                <>
                                    Join Today
                                    <img src={ddArrow} alt="arrow-right"/>
                                </>
                            } 
                            onclick={executeScroll}
                            type="primary" 
                            extraClasses="text-3-2 cta-arrow-btn btn-radius6" />
                    </div>
                </div>
            </div>

            <div className="in-ab2801-integrations">
                <div className='in-ab2801-integrations-bg'>
                    <img src={gridBG} alt="bg"/>
                </div>
                <div className="in-ab2801-integrations-content" style={{paddingTop: '100px'}}>
                    <h2 className="h2" style={{margin: "0 auto 16px", width: 'fit-content', textAlign: 'center'}}>
                        Integrations
                    </h2>
                    <div className="text-1" style={{textAlign: 'center'}}>
                        Our platform integrates seamlessly with your existing operation, communication, maintenance, or property management softwares —<br/>
                        so you can keep everything connected, avoid duplicate work, 
                        and stay focused on what matters.
                    </div>
                    <div className="integration-items mx-auto" style={{margin: '36px auto 50px', maxWidth: "70vw"}}>
                        <div className="flexRow">
                            <img src={buildiumLogo} alt="Buildium" />
                            <img src={rentManagerLogo} alt="rentManager" />
                        </div>
                        <div className="flexRow">
                            <img src={appfolioLogo} alt="Appfolio" />
                            <img src={rentvineLogo} alt="Rentvine" />
                        </div>
                        <div className="flexRow">
                            <img src={propertywareLogo} alt="Propertyware" />
                            <img src={arthurLogo} alt="Arthur" />
                        </div>
                    </div>
                </div>
            </div>

            <div className='in-homepage-faqs in-homepage-section-simple'>
                <div className='in-homepage-faqs-content flexRow'>
                    <div className='in-homepage-faqs-text flexColumn'>
                        <div className='h2'>
                            Frequently<br/>
                            Asked Questions
                        </div>
                        <div className='text-1'>
                            Do you have any more questions?
                        </div>
                        <div className='flexRow'>
                            {/* <Btn 
                                text="View all FAQs"
                                type="primary" 
                                extraClasses="text-1-3 btn-radius6 btn-no-break" /> */}
                            <Btn 
                                text="Speak to one of our experts"
                                onclick={executeScroll}
                                type="primary" 
                                extraClasses="text-1 btn-radius6 btn-no-break" />
                        </div>
                    </div>
                    <div className='in-homepage-faqs-media'>
                        {
                            [
                                {
                                    title: "How does Paraspot AI benefit property managers and operators?",
                                    content: (
                                        "Paraspot AI revolutionizes property management by streamlining operations and improving efficiency. " +
                                        "With AI-guided inspections, property managers can eliminate costly, time-consuming site visits and " +
                                        "instead rely on accurate, remote inspections. The platform automates property condition reporting, " +
                                        "delivering real-time, detailed assessments that reduce human error and provide undeniable proof of " +
                                        "damages or wear. By empowering tenants to conduct inspections themselves, Paraspot minimizes " +
                                        "disputes, accelerates turnover times, and enhances tenant satisfaction. It's a cost-effective, " +
                                        "scalable solution that allows you to focus on growing your portfolio while automating day-to-day tasks."
                                    )
                                },
                                {
                                    title: "Why switch from manual inspections to AI-powered inspections?",
                                    content: (
                                        "Switching to AI-guided inspections transforms your property management process. With manual inspections, " +
                                        "you face time-consuming site visits, human error, and inconsistent reporting. AI-driven inspections, on " +
                                        "the other hand, provide precise, automated documentation without ever stepping foot on the property. You " +
                                        "can reduce costs by up to 90%, eliminate repetitive tasks, and get real-time, unbiased reports with " +
                                        "undeniable proof of property conditions. Tenants actively participate in the process, resulting in fewer " +
                                        "disputes and faster resolutions. It's a smarter, faster, and more accurate way to manage your properties. "
                                    )
                                },
                                {
                                    title: "What is California Regulation \"AB 2801\" and how does it impact property managers?",
                                    content: (
                                        "AB2801 is a new California law that requires landlords and property managers " + 
                                        "to perform detailed, documented inspections of rental properties at move-in and move-out. " + 
                                        "The goal is to prevent disputes over security deposits by providing clear proof of the property's " + 
                                        "condition. Failure to comply can result in penalties, tenant lawsuits, and lost disputes."
                                    )
                                },
                                {
                                    title: "How does Paraspot help me comply with AB 2801?",
                                    content: (
                                        "Paraspot creates a full, irrefutable property condition record through a single guided video walkthrough. " + 
                                        "Our AI automatically detects damages, adds descriptions and price estimates, and generates " + 
                                        "before-and-after comparisons. This ensures you're fully covered under AB2801 — " + 
                                        "without wasting time on manual photos or paperwork."
                                    )
                                },
                                {
                                    title: "Why is a video based inspections better than taking photos?",
                                    content: (
                                        "Photos can miss parts of the property or fail to capture the true condition. A video walkthrough " + 
                                        "records everything — every wall, floor, ceiling, and corner — in a single, continuous session. " + 
                                        "It's faster, more complete, and leaves no room for disputes."
                                    )
                                },
                                {
                                    title: "How can I be sure tenants are accurately capturing all details and not missing or hiding anything?",
                                    content: (
                                        "Paraspot AI ensures that every inspection is thorough and accurate by guiding tenants step-by-step through " +
                                        "the process. Our AI-driven system validates the quality of the scan in real-time, ensuring that all areas " +
                                        "of the property are covered. If any part of the property is skipped or improperly scanned, the system flags " +
                                        "it for review, preventing missed details. Additionally, the technology detects inconsistencies or attempts " +
                                        "to hide damage, providing you with full transparency and confidence in the results. With time-stamped and " +
                                        "geo-tagged reports, you get an irrefutable record of the inspection, ensuring tenants can't omit critical information. "
                                    )
                                },
                                {
                                    title: "How long does an inspection take with Paraspot?",
                                    content: (
                                        "Most properties can be fully inspected in under 4 minutes — compared to 1-2 hours with traditional methods."
                                    )
                                },
                                {
                                    title: "Can Paraspot help reduce operational costs?",
                                    content: (
                                        "Absolutely. Paraspot significantly reduces operational costs by automating property inspections and eliminating " +
                                        "the need for on-site visits. With our AI-guided inspections, property managers no longer have to spend time and " +
                                        "resources on manual checks. The platform generates detailed, accurate reports remotely, cutting inspection costs " +
                                        "by up to 90%. Additionally, it speeds up turnover times, minimizes tenant disputes, and reduces expenses related " +
                                        "to dispute resolution. By streamlining these processes, Paraspot allows you to manage more properties with fewer " +
                                        "resources, leading to substantial savings across your operations. "
                                    )
                                },
                                {
                                    title: "What is included in Paraspot's property condition assessments?",
                                    content: (
                                        "Paraspot's property condition assessments are comprehensive and highly detailed. Our AI-driven system captures " +
                                        "high-quality scans of the entire property, including its interior, furnishings, and appliances. It automatically " +
                                        "detects damages such as cracks, stains, and wear and tear, while also documenting the condition of key elements " +
                                        "like flooring, walls, and fixtures. The assessment includes time-stamped, geo-tagged data for accuracy, and generates " +
                                        "an easy-to-read report with visual evidence. This ensures that every detail is accounted for, providing clear proof of " +
                                        "the property's condition at both move-in and move-out. "
                                    )
                                },
                                {
                                    title: "How does Paraspot ensure the accuracy of its inspection results?",
                                    content: (
                                        "Paraspot guarantees inspection accuracy with its AI, which is trained on over 7 million data points and continuously " +
                                        "learns from thousands of ongoing inspections. This ensures ever-improving precision and consistency. Our system " +
                                        "automatically detects damages—such as cracks, stains, or wear—and captures high-quality scans, reducing human error. " +
                                        "Each inspection is backed by time-stamped, geo-tagged reports, providing verifiable proof of the property's condition. " +
                                        "Additionally, Paraspot's AI compares before-and-after scans to identify discrepancies, ensuring a reliable and  " +
                                        "transparent assessment every time. "
                                    )
                                },
                                {
                                    title: "What kind of support does Paraspot offer to its users?",
                                    content: (
                                        "Paraspot offers comprehensive support to ensure a seamless experience for all users. We provide onboarding assistance, " +
                                        "personalized training sessions, and ongoing technical support to help you get the most out of our platform. Users also " +
                                        "have access to detailed resources such as the onboarding process guide, FAQs, and dedicated customer support for any " +
                                        "issues or questions. Our team is committed to helping you streamline property management and maximize the benefits of Paraspot AI. "
                                    )
                                },
                                {
                                    title: "How does Paraspot deliver the best automated property inspections?",
                                    content: (
                                        "Paraspot excels at automated property inspections by leveraging advanced AI, developed by a team with deep expertise in both " +
                                        "AI and real estate. Our technology accurately detects damages, guides tenants through a seamless process, and produces high-quality,  " +
                                        "time-stamped reports. Continuous learning from thousands of inspections ensures precision and efficiency, reducing human error " +
                                        "and improving over time. "
                                    )
                                },
                            ].map((item, index) => {
                                return (
                                    <div key={index} className='in-homepage-faqs-media-item flexColumn' onClick={() => { setShowFaq(showFaq === index ? null : index) }}>
                                        <div className='in-homepage-faqs-media-item-main flexRow'>
                                            <div className='text-1-3 in-faqs-number'>{index < 9 ? `0${index+1}` : index+1}</div>
                                            <h3 className='text-1-3 in-faqs-text'>
                                                {item.title}
                                            </h3>
                                            <div className='h2-2'>{showFaq === index ? "-" : "+"}</div>
                                        </div>
                                        <div className={`in-faqs-expanded${showFaq === index ? " in-faqs-expanded-show-a" : ""}`}>
                                            <p className='text-1'>
                                                {item.content}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>

            <ContactForm
                scrollToForm={scrollToForm}
                clientData={clientData}
                title={"Get a Quote Today!"}
                para_be={props.para_be}
                setNotifState={setNotifState} />

            <div className='in-homepage-pre-footer in-homepage-section-simple'>
                <img className='in-homepage-pre-footer-bg' src={gridBG} alt="bg"/>
                <div className='in-homepage-pre-footer-radial1'/>
                <div className='in-homepage-pre-footer-radial2'/>

                <div className='in-homepage-pre-footer-content flexRow'>
                    <div className='in-homepage-pre-footer-text flexColumn'>
                        <h1 className='h1'>
                            Ready to put your<br/>
                            property operations<br/>
                            on autopilot?
                        </h1>
                        <h2 className='text-0'>
                            Experinece effortless management with AI-powered<br/>
                            inspections, and focus on what truly matters.
                        </h2>
                        <Btn 
                            text={
                                <>
                                    Join Today
                                    <img src={ddArrow} alt="arrow-right"/>
                                </>
                            } 
                            onclick={executeScroll}
                            type="primary-black" 
                            extraClasses="text-3-2 cta-arrow-btn btn-radius6" />
                    </div>
                    <div className='in-homepage-pre-footer-media'>
                        <img src={dashboardImg} alt="Paraspot AI operations management dashboard"/>
                    </div>
                </div>
            </div>

            <div className="in-homepage-footer">
                <div className='in-homepage-footer-content'>
                    <div className='in-homepage-footer-content-top flexRow'>
                        <div className='flexColumn'>
                            <h1 className='h2'>
                                Transform Inspections,<br/>
                                Elevate Efficiency - <br/>
                                Powered by AI.
                            </h1>
                            <div className="flexRow">
                                <a className='footer-social-icon' href="https://www.linkedin.com/company/paraspot-gmbh" target="_blank" rel="noreferrer">
                                    <img src={linkedin} alt="linkedIn"/>
                                </a>
                                <a className='footer-social-icon' href="https://www.facebook.com/paraspotAI" target="_blank" rel="noreferrer">
                                    <img src={facebook} alt="facebook"/>
                                </a>
                                <a className='footer-social-icon' href="https://www.instagram.com/paraspot_ai/" target="_blank" rel="noreferrer">
                                    <img src={instagram} alt="instagram"/>
                                </a>
                                <a className='footer-social-icon' href="https://twitter.com/paraspot" target="_blank" rel="noreferrer">
                                    <img src={twitter} alt="twitter"/>
                                </a>
                            </div>
                        </div>
                        <div className='footer-sitemap flexRow d-none'>
                            <div className='footer-sitemap-column'>
                                <div className='text-1-3'>Solutions</div>
                                <Link to="/solutions/multifamily" className='text-1'>Multifamily</Link>
                                <Link to="/solutions/single-family" className='text-1'>Single Family</Link>
                                <Link to="/solutions/student-housing" className='text-1'>Student Housing</Link>
                                <Link to="/solutions/furnished-rental-co-living" className='text-1'>Furnished Rental &<br/>Co-Living</Link>
                                <Link to="/solutions/str" className='text-1'>Short-Term Rentals</Link>
                            </div>
                            <div className='footer-sitemap-column'>
                                <div className='text-1-3'>Resources</div>
                                <Link to="/resources/blog" className='text-1'>Blog</Link>
                                <Link to="/resources/faqs" className='text-1'>FAQs</Link>
                                <Link to="/resources/integrations" className='text-1'>Integrations</Link>
                                <Link to="/resources/documentation" className='text-1'>API Documentation</Link>
                            </div>
                            <div className='footer-sitemap-column'>
                                <div className='text-1-3'>About Us</div>
                                <Link to="/about-us/out-mission" className='text-1'>Our Mission</Link>
                                <Link to="/about-us/team" className='text-1'>Team</Link>
                                <Link to="/about-us/contact-us" className='text-1'>Contact Us</Link>
                            </div>
                        </div>
                    </div>
                    <div className='in-homepage-footer-content-bottom flexRow'>
                        <div className='text-1'>© Paraspot 2024</div>
                        <div className='flexRow'>
                            <div 
                                className='text-1'
                                onClick={() => {
                                    window.ml('show', 'aE4eoX', true);
                                }}
                            >
                                Subscribe to Newsletter
                            </div>
                            <div className='text-1'>Terms & Conditions</div>
                            <div className='text-1'>Privacy Policy</div>
                        </div>
                    </div>
                </div>
            </div>

            {notifState ?
                <Notification
                    closeFunc={() => setNotifState(null)}
                    text={notifState.text}
                    type={notifState.type}/> : ""
            }
            {popupState ? <MasterPopup {...popupState[1]}>{popupState[0]}</MasterPopup> : ""}
        </div>
    )
}